/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.cta-form-section {
  max-width: 1920px;
  padding-left: 16px;
  padding-right: 16px;
  margin: 0 auto;
}

@media (min-width: 1000px) {
  .cta-form-section {
      padding-left: 40px;
      padding-right: 40px;
  }
}

@media (min-width: 1600px) {
  .cta-form-section {
      padding-left: 60px;
      padding-right: 60px;
  }
}

.form-icon-wrapper {
  @apply max-sm:w-5/6 max-md:w-4/6 max-md:mx-auto max-md:-translate-y-40px bg-medium-blue px-24px md:px-40px py-44px md:py-64px gap-y-36px text-white  flex flex-col justify-center items-start rounded-xl z-10 relative; 

}

.form-subtitle {
  @apply max-w-[500px] mr-auto pt-16px z-10;
}

.form-icon {
  @apply max-w-xs h-64px w-auto bg-white aspect-square;
  mask-repeat: no-repeat;
}

.cta-form-wrapper {
  @apply bg-dark-blue text-white flex flex-col justify-center items-center px-24px py-48px md:p-72px rounded-xl relative ;
  margin: 0 auto;
}

.cta-form-svg {
  @apply absolute bottom-0 right-0 w-[168px] h-200px md:h-[300px] md:w-[250px];
  z-index: 5;
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/color-icons/form-bg.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.cta-form-svg.hide {
  @apply max-lg:hidden;
}


.cta-form {
  @apply w-full min-h-[600px] !important;
  z-index: 10;
}

@media(min-width: 1000px ) {
  .cta-form {
    @apply w-5/6 mr-auto !important;
  }
  .cta-form-section {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .form-icon-wrapper {
    grid-column: 7 / span 7; /* Span 6 columns starting from column 4 */
    grid-row: 2 / span 2; /* Span 2 rows starting from row 1 (for overlap) */
  }

  .cta-form-wrapper.wide {
    width: 100%;
    grid-column: 1 / span 12; /* Span 6 columns starting from column 4 */
    grid-row: 1/ span 4; /* Span 2 rows starting from row 1 (for overlap) */


  }

  .cta-form-wrapper.wide .cta-form {
    @apply !max-w-[700px] mx-auto;
  }

  .cta-form-wrapper {
    grid-column: 1 / span 7; /* Span 7 columns starting from column 1 */
    grid-row: 1 / span 4; /* Span 2 rows starting from row 1 (for overlap) */
  }
}

.cta-form .mktoFormRow{
  @apply text-white w-full;
}

.cta-form .mktoFormRow .mktoFormCol {
  @apply w-full;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap .mktoHasWidth {
  @apply w-full !important;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap {
  @apply flex !flex-col-reverse w-full;
}

/* Checkbox */

.mktoForm .mktoCheckboxList > label {
  @apply ml-44px !important;
}
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap {
  @apply -text-1 md:text-0  w-full mb-12px !important;
}
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="emailoptin"] {
  @apply w-fit -text-1 md:text-0 !important;
}
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap input[type="checkbox"] {
  @apply accent-yellow text-white h-20px w-20px ml-12px !important;
}

/* Form Inputs */
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="FirstName"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="LastName"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="Email"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="Company"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="Phone"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="Country"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="State"],
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap label[for="Title"] {
  @apply w-full min-w-[100%] sr-only !important;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap .mktoField {
  @apply py-8px px-12px w-full bg-dark-blue border-2 border-white text-white focus-within:outline-2 outline-light-blue max-w-[700px] !important;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap .mktoField input {
  @apply !border-2 !border-t-2 !border-l-2 !border-r-2 max-w-[700px];
}

.cta-form.mktoForm .mktoFormRow,
.cta-form.mktoForm .mktoButtonRow {
  @apply min-w-[100%] max-w-[100%] !important;
}

.cta-form.mktoForm .mktoFormRow[style*="width:0px"],
.cta-form.mktoForm .mktoFormRow[style*="width: 0px"] {
    @apply !hidden;
}

.cta-form.mktoForm .mktoFormRow textarea.mktoField {
  text-indent: 0px !important;
}

.cta-form.mktoForm .mktoFormRow select,
.cta-form.mktoForm .mktoFormRow input[type="text"],
.cta-form.mktoForm .mktoFormRow input[type="email"],
.cta-form.mktoForm .mktoFormRow input[type="tel"],
.cta-form.mktoForm .mktoFormRow textarea {
  @apply min-w-[100%] max-w-[100%] rounded-[4px] !important;
  border: 2px solid #fff !important;
}

.cta-form.mktoForm .mktoFormRow select.mktoInvalid,
.cta-form.mktoForm .mktoFormRow input[type="text"].mktoInvalid,
.cta-form.mktoForm .mktoFormRow input[type="email"].mktoInvalid,
.cta-form.mktoForm .mktoFormRow input[type="tel"].mktoInvalid,
.cta-form.mktoForm .mktoFormRow textarea.mktoInvalid {
  border: 2px solid var(--orange) !important;
}

.cta-form.mktoForm .mktoFormRow .mktoErrorMsg {
  @apply font-poppins text-0 font-medium !important;
  color: var(--orange) !important;
}

.cta-form.mktoForm .mktoFormRow select:focus,
.cta-form.mktoForm .mktoFormRow input[type="text"]:focus,
.cta-form.mktoForm .mktoFormRow input[type="email"]:focus,
.cta-form.mktoForm .mktoFormRow input[type="tel"]:focus,
.cta-form.mktoForm .mktoFormRow textarea:focus {
  border: 2px solid var(--light-blue) !important;
  caret-color: var(--light-blue);
}

.cta-form.mktoForm .mktoFormRow select {
  position: relative;
  -webkit-appearance: none;  /* Removes default Chrome and Safari styling */
  -moz-appearance: none;     /* Removes default Firefox styling */
  appearance: none; 
}
.cta-form.mktoForm .mktoFormRow select::-ms-expand {
  display: none;  /* Hides the default dropdown arrow in IE */
}

.cta-form.mktoForm .mktoFormRow select {
  background-image: url("/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/form-select-arrow.svg") !important;
  background-repeat: no-repeat !important;
  background-position: calc(100% - 16px) center !important;  /* Adjusts the position of the arrow */
  background-size: 10px 8px !important;    /* Size of the arrow */
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap input[type="checkbox"] {
  appearance: none; /* Remove default system appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent; /* Transparent background */
  border: 2px solid white; /* White border */
  min-width: 20px; /* Set a fixed width */
  min-height: 20px; /* Set a fixed height */
  margin-left: 0px !important;
  cursor: pointer; /* Pointer cursor on hover */
  position: relative;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap input[type="checkbox"]:hover {
  border: 2px solid var(--light-blue);
}

/* Styling for when the checkbox is checked */
.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap input[type="checkbox"]:checked {
  background-color: var(--light-blue); /* White background on checked */
  border: 2px solid var(--light-blue);
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap input[type="checkbox"]:checked:after {
  content: "\2713"; /* Unicode character for a checkmark */
  position: absolute; /* Absolute positioning inside the checkbox */
  left: 50%; /* Center the checkmark horizontally */
  top: 50%; /* Center the checkmark vertically */
  transform: translate(-50%, -50%); /* Adjust the position to truly center it */
  color: var(--medium-blue); /* Color of the checkmark */
  font-size: 14px; /* Size of the checkmark */
}

.cta-form.mktoForm .mktoHtmlText.mktoHasWidth {
  @apply w-full !important;
}

.cta-form.mktoForm .mktoHtmlText.mktoHasWidth a {
  @apply text-orange p-0 !important;
  transition: color 0.15s ease;
}

.cta-form.mktoForm .mktoHtmlText.mktoHasWidth a:hover {
  @apply text-yellow !important;
}

.cta-form.mktoForm .mktoHtmlText .optinsection,
.cta-form.mktoForm .mktoHtmlText div {
  @apply w-full min-w-[100%] max-w-[100%] flex flex-row gap-x-[6px] items-start justify-start !important;
}

.cta-form .mktoFormRow .mktoFormCol .mktoFieldWrap .mktoField::placeholder {
  @apply text-white  !important;
}

/* Form Button */
.cta-form .mktoButtonRow .mktoButtonWrap {
  @apply ml-0 !important;
}

.cta-form .mktoButtonRow .mktoButtonWrap button.mktoButton {
  @apply bg-orange text-dark-blue w-fit border-2 border-orange transition-colors font-medium !important;
  background-image: none !important;
}

.cta-form .mktoButtonRow .mktoButtonWrap button.mktoButton:hover {
  background-color: #E4B700 !important;
  border-color: #E4B700 !important;
}

/* Form Error */
.mktoError {
  @apply bg-none text-red relative bottom-0 right-0  !important;
}

.mktoError .mktoErrorMsg {
  @apply mt-0 text-red -text-2 md:-text-1 font-semibold border-none shadow-none bg-none max-w-none p-0 !important;
  background-color: transparent !important;
  text-shadow: none !important;
}
.mktoError .mktoErrorArrowWrap {
  @apply hidden;
}

/* Marketo Form 157 Spacing Fix */
#mktoForm_157 .mktoOffset,
#mktoForm_157 .mktoGutter {
  @apply hidden !important;
}

/* Animation */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2 {
  @apply absolute bg-white w-full h-full top-0 left-0 rounded-xl z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.cta-form-section.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.cta-form-section.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

